<template>
    <input
        :id="question.label"
        type="number"
        style="width: 100%"
        :placeholder="question.placeholder"
        @input="$emit('input', Number($event.target.value))"
    />
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    }
};
</script>
